import { CSSProperties, ReactElement, ReactNode } from 'react'

import { Divider } from 'antd'
import classNames from 'classnames'

import { Flex } from 'components/core'

import * as styles from './styles.module.scss'

interface Props {
    header?: ReactNode
    title: ReactNode
    subtitle?: ReactNode
    footer?: ReactNode
    extraActions?: ReactNode[]
    extraActionsStyles?: CSSProperties
}

const MinimalTitle = ({
    header,
    title,
    subtitle,
    footer,
    extraActions = [],
    extraActionsStyles,
}: Props): ReactElement => (
    <Flex
        direction="column"
        alignItems="normal"
        className={styles.minimalTitleContainer}
    >
        {header && (
            <>
                {header}
                <Divider className={styles.headerDivider} />
            </>
        )}
        <Flex justifyContent="space-between" className={styles.fullWidth}>
            <Flex direction="column" alignItems="start" justifyContent="center">
                {title}
                <span className={styles.subtitle}>{subtitle}</span>
            </Flex>
            <Flex
                justifyContent="center"
                style={extraActionsStyles}
                className={classNames(styles.extraActions)}
            >
                {extraActions.map((action, index) => (
                    <div key={index}>{action}</div>
                ))}
            </Flex>
        </Flex>
        {footer && <Flex className={styles.titleFooter}>{footer}</Flex>}
    </Flex>
)

export { MinimalTitle }
